import React from 'react';
import { BookOpenIcon, DumbbellIcon, AtomIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Features() {
  const features = [{
    icon: BookOpenIcon,
    title: '2500 Años de Sabiduría, Actualizada al 2026',
    description: 'Las enseñanzas más poderosas del budismo, traducidas a un lenguaje moderno, directo y aplicable a tu día a día.'
  }, {
    icon: DumbbellIcon,
    title: 'Ejercicios Prácticos para el Trabajo y el Hogar',
    description: 'Meditaciones guiadas breves, técnicas de respiración y rituales diarios que puedes empezar a usar hoy mismo.'
  }, {
    icon: AtomIcon,
    title: 'Métodos Respaldados por la Neurociencia',
    description: 'Cada técnica está validada por estudios científicos modernos sobre el cerebro, la reducción del estrés y el bienestar.'
  }];
  return <section className="py-24 bg-[#0A192F] relative overflow-hidden" data-id="element-33">
      {/* Decorative background element */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#D4AF37]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-34" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-35">
        <div className="text-center mb-20" data-id="element-36">
          <span className="text-[#D4AF37] font-['Inter'] font-semibold tracking-[0.2em] text-sm mb-4 block uppercase" data-id="element-37">
            La Solución
          </span>
          <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#FFF8F0]" data-id="element-38">
            Lo que este libro hará por ti
          </h2>
        </div>

        <div className="space-y-12" data-id="element-39">
          {features.map((feature, index) => <motion.div key={index} className="flex flex-col md:flex-row gap-8 items-start md:items-center bg-[#112240]/50 p-8 rounded-2xl border border-[#1D3461]/50" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-40">
              <div className="flex-shrink-0 w-20 h-20 rounded-full border border-[#D4AF37] flex items-center justify-center bg-[#0A192F]" data-id="element-41">
                <feature.icon className="w-8 h-8 text-[#D4AF37]" strokeWidth={1.5} data-id="element-42" />
              </div>
              <div data-id="element-43">
                <h3 className="text-2xl font-['Playfair_Display'] text-[#FFF8F0] mb-3" data-id="element-44">
                  {feature.title}
                </h3>
                <p className="text-[#A8B2D1] font-['Inter'] text-lg leading-relaxed" data-id="element-45">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}